var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPriceTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  viewBox: "0 0 21 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M19.74 0h-8.053c-.334 0-.655.132-.89.37L.369 10.797a1.26 1.26 0 0 0 0 1.782l8.052 8.052c.493.49 1.29.49 1.782 0l10.428-10.429c.237-.236.37-.557.369-.89V1.26C20.999.564 20.435 0 19.74 0Zm-4.2 7.56a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2Z"
})));
export default SvgPriceTag;